import AxiosClient from '../../../../services/axios.services';

class DashboardSelecVacantesServices {
  getDashboarSelecVacantes = params => AxiosClient.get('/api/app/seleccion_contratacion_dashboard_vacantes/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
}

export default new DashboardSelecVacantesServices();

//seleccion_contratacion_dashboard_motivo_solicitud
//seleccion_contratacion_dashboard_contrataciones
//seleccion_contratacion_dashboard_vacantes